import { createFileRoute, redirect } from '@tanstack/react-router'

// Redirector: /org/$orgId/projects/$projectId/documents/$docId -> /org/$orgId/projects/$projectId/document/$docId
export const Route = createFileRoute(
  '/_authenticated/org/$orgId/projects/$projectId/documents/$docId',
)({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: '/org/$orgId/projects/$projectId/document/$docId',
      params,
    })
  },
  component: () => null,
})
